<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="true"
        autocomplete="off"
      >
        <v-card>
          <v-card-title>
            <span class="headline primary--text font-weight-bold">Nuova Nota</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="title"
                    label="Titolo*"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="priority"
                    :items="priorities"
                    item-text="text"
                    item-value="value"
                    label="Priorità*"
                    return-object
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="body"
                    label="Descrizione*"
                    :rules="[rules.required]"
                    required
                  ></v-textarea>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="deadline"
                        label="Deadline"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="deadline"
                      no-title
                      scrollable
                      actions
                      locale="it-IT"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="deadline = null"
                      >Rimuovi</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="assignee"
                    :items="users"
                    label="Assegnatario"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </v-col>
              </v-row>
              <small>*campo obbligatorio.</small>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="create"
            >Salva</v-btn>
            <v-btn
              color="primary"
              @click="dismiss"
            >Annulla</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    name: 'Create',
    props: {
      dialog: { type: Boolean, default: false },
      users: { type: Array, default: () => [] },
      priorities: { type: Array, default: () => [] }
    },

    data() {
      return {
        menu: false,
        valid: false,
        rules: {
          required: (value) => !!value || 'Campo obbligatorio.',
        },
      }
    },

    methods: {
      ...mapMutations([
        'SET_NEW_NOTE_TITLE',
        'SET_NEW_NOTE_BODY',
        'SET_NEW_NOTE_PRIORITY',
        'SET_NEW_NOTE_ASSIGNEE',
        'SET_NEW_NOTE_DEADLINE',
      ]),

      ...mapActions(['fetchNotes', 'createNote']),

      dismiss() {
        this.$emit('dismiss')
      },

      create() {
        if (this.$refs.form.validate()) {
          this.createNote().then((status) => {
            if (status) {
              this.$emit('saved')
            }
          })
        }
      },
    },

    computed: {
      ...mapGetters({
        nota: 'getNewNote',
      }),

      title: {
        get() {
          return this.nota.title
        },
        set(value) {
          this.SET_NEW_NOTE_TITLE(value)
        },
      },

      body: {
        get() {
          return this.nota.body
        },
        set(value) {
          this.SET_NEW_NOTE_BODY(value)
        },
      },

      priority: {
        get() {
          return this.nota.priority
        },
        set({ value }) {
          this.SET_NEW_NOTE_PRIORITY(value)
        },
      },

      assignee: {
        get() {
          return this.nota.assignee
        },
        set(value) {
          this.SET_NEW_NOTE_ASSIGNEE(value)
        },
      },

      deadline: {
        get() {
          return this.nota.deadline
        },
        set(value) {
          this.SET_NEW_NOTE_DEADLINE(value)
        },
      },
    },
  }
</script>

<style></style>
